import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaBell, FaEnvelope } from "react-icons/fa";

const NewsletterSignup = () => {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("success");
  const [error, setError] = useState("");

  const showToastMsg = (msg, type = "success") => {
    setToastMessage(msg);
    setToastType(type);
    setShowToast(true);
    setTimeout(() => setShowToast(false), 4000);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      setError("Email is required");
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError("Please enter a valid email");
      return;
    }
    setError("");
    setIsSubmitting(true);

    try {
      const response = await fetch(
        "https://us-central1-timeclock-f2c1a.cloudfunctions.net/newsLetter",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        }
      );
      if (response.ok) {
        showToastMsg("You're subscribed! Welcome aboard.");
        setEmail("");
      } else {
        showToastMsg("Subscription failed. Please try again.", "error");
      }
    } catch {
      showToastMsg("Network error. Please try again later.", "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="relative">
      {/* Toast */}
      <AnimatePresence>
        {showToast && (
          <motion.div
            initial={{ opacity: 0, y: -16, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -16, scale: 0.95 }}
            transition={{ duration: 0.3 }}
            className={`fixed top-20 right-6 z-50 px-5 py-3 rounded-xl shadow-lg text-sm font-semibold ${toastType === "success" ? "bg-accent text-primary" : "bg-red-500 text-white"
              }`}
          >
            {toastMessage}
          </motion.div>
        )}
      </AnimatePresence>

      <div className="bg-gradient-to-br from-primary to-secondary rounded-3xl p-8 md:p-12 text-white relative overflow-hidden">
        {/* Decorative elements */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -translate-y-1/2 translate-x-1/2 blur-2xl" />
        <div className="absolute bottom-0 left-0 w-48 h-48 bg-accent/10 rounded-full translate-y-1/2 -translate-x-1/2 blur-2xl" />

        <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-8">
          <div className="flex-1">
            <div className="inline-flex items-center gap-2 px-3 py-1 bg-white/10 rounded-full text-xs font-medium mb-4 backdrop-blur-sm">
              <FaBell className="text-accent" />
              Stay Updated
            </div>
            <h2 className="text-2xl md:text-3xl font-bold mb-2" style={{ fontFamily: "'Poppins', sans-serif" }}>
              Get the Latest Updates
            </h2>
            <p className="text-white/60 text-sm max-w-md">
              Subscribe to our newsletter for product updates, tips, and workforce management insights.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="w-full md:w-auto flex-shrink-0">
            <div className="flex flex-col sm:flex-row gap-3">
              <div className="relative flex-1 min-w-[260px]">
                <FaEnvelope className="absolute left-4 top-1/2 -translate-y-1/2 text-white/40 text-sm" />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => { setEmail(e.target.value); setError(""); }}
                  placeholder="Enter your email"
                  className="w-full pl-10 pr-4 py-3 bg-white/10 border-2 border-white/10 rounded-xl text-sm text-white placeholder-white/40 backdrop-blur-sm focus:border-white/30 focus:ring-2 focus:ring-white/10 outline-none transition-all duration-300"
                />
              </div>
              <motion.button
                type="submit"
                disabled={isSubmitting}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                className="btn bg-white text-primary hover:bg-white/90 font-bold rounded-xl px-6 py-3 disabled:opacity-50"
              >
                {isSubmitting ? "Subscribing..." : "Subscribe"}
              </motion.button>
            </div>
            {error && <p className="text-red-300 text-xs mt-2">{error}</p>}
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewsletterSignup;